import { createContext, useContext } from 'react';

const noop = () => {};

// ambient is Gladys' mood from the portfolio pulse (null until known).
export const ShellContext = createContext({ openChat: noop, openPalette: noop, ambient: null });

export const useShell = () => useContext(ShellContext);
